var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Alert, Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, Toggle, Typography, } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { getWindow } from '../../../utils/general';
export var PHTableSettingsDrawer = function (_a) {
    var enableSettingsDrawer = _a.enableSettingsDrawer, setEnableSettingsDrawer = _a.setEnableSettingsDrawer, tableHeaderState = _a.tableHeaderState, setTableHeaderState = _a.setTableHeaderState;
    var _b = useState(false), showAlert = _b[0], setShowAlert = _b[1];
    var _c = useState(tableHeaderState), tableHeaders = _c[0], setTableHeaders = _c[1];
    var handleToggle = function (index) {
        setTableHeaders(function (prevState) {
            var updatedHeaders = __spreadArray([], prevState, true);
            updatedHeaders[index] = __assign(__assign({}, updatedHeaders[index]), { enabled: !updatedHeaders[index].enabled });
            return updatedHeaders;
        });
    };
    var closeModal = function () { return setEnableSettingsDrawer(false); };
    var handleApply = function () {
        var _a;
        var hasAtLeastOneEnabled = tableHeaders.some(function (header) { return header.enabled === true; });
        if (!hasAtLeastOneEnabled) {
            setShowAlert(true);
            return;
        }
        var tableStringify = JSON === null || JSON === void 0 ? void 0 : JSON.stringify(tableHeaders);
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('tableHeaders', tableStringify);
        setTableHeaderState(tableHeaders);
        closeModal();
    };
    return (React.createElement("div", { className: "sui-relative sui-outline-0 sui-m-auto sui-flex sui-gap-4 sui-justify-center sui-pt-4 sui-pb-28 sui-h-[600px]" },
        React.createElement(React.Fragment, null,
            React.createElement(Drawer, { open: enableSettingsDrawer, onClose: closeModal, position: "right" },
                React.createElement(DrawerHeader, { title: "Customize Table", onClose: closeModal }),
                React.createElement(DrawerBody, null,
                    React.createElement("div", { className: "sui-mb-[29px]" },
                        React.createElement(Typography, { variant: "body-base" }, "Select the columns you would like to see in Tableview:")),
                    showAlert && (React.createElement(Alert, { status: "error", size: "large" }, "You must make at least one selection.")),
                    React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-[12px]" }, tableHeaders.map(function (header, index) {
                        var _a, _b, _c;
                        if ((header === null || header === void 0 ? void 0 : header.showToggle) === false) {
                            return null;
                        }
                        return (React.createElement("button", { key: index, type: "button", className: "sui-flex sui-items-center sui-gap-[16px] sui-bg-transparent sui-border-0 sui-p-0 sui-text-left sui-cursor-pointer", onClick: function () { return handleToggle(index); }, "aria-pressed": (_a = header === null || header === void 0 ? void 0 : header.enabled) !== null && _a !== void 0 ? _a : false },
                            React.createElement(Toggle, { checked: (_b = header === null || header === void 0 ? void 0 : header.enabled) !== null && _b !== void 0 ? _b : false, inputAttributes: { 'aria-label': 'controlled' } }),
                            ' ',
                            React.createElement(Typography, { variant: "body-base" }, (_c = header === null || header === void 0 ? void 0 : header.columnName) !== null && _c !== void 0 ? _c : '')));
                    }))),
                React.createElement(DrawerFooter, null,
                    React.createElement("div", { className: "ButtonGroup sui-flex sui-flex-col sui-gap-2" },
                        React.createElement(Button, { fullWidth: true, onClick: handleApply }, "Apply"),
                        React.createElement(Button, { variant: "secondary", fullWidth: true, onClick: closeModal }, "Cancel")))))));
};
